export function interactiveMap() {
    const $window = $(window);
    const $header = $(".header");
    const $parent = $(".interactive-map");
    let usaMap = $parent.find(".usa-map");
    let pinsMap = $parent.find(".pins-map");
    let mapInfoItem = $parent.find(".interactive-map-slider .item");
    mapInfoItem.each(function () {
        let $this = $(this);
        let stateName = $this.find(".interactive-map-info").attr("data-state-name");
        let state = usaMap.find("path[data-name='" + stateName + "']");
        let stateId = state.attr("id");
        state.addClass("active");
        let statePin = pinsMap.find("g[id='" + stateId + "-pin']").find("path");
        statePin.addClass("active");
    });
    usaMap.find("path").on("click", function (e) {
        let $this = $(this);
        if ($this.hasClass("active")) {
            let showId = $this.data("id");
            let showState = $this.data("name");
            usaMap.find("path.active").addClass("hide");
            $this.addClass("show").removeClass("hide");
            pinsMap.find("g path.active").addClass("hide");
            pinsMap.find("g[id='" + showId + "-pin']").find("path").removeClass("hide");
            mapInfoItem.removeClass("show");
            mapInfoItem.find(".interactive-map-info[data-state-name='" + showState + "']").parent().addClass("show");
            let left = e.offsetX;
            let top = e.offsetY;
            mapInfoItem.css({
                "left": left,
                "top": top
            });
            setTimeout(function () {
                if (mapInfoItem.find(".interactive-map-info[data-state-name='" + showState + "']").offset().top < $window.scrollTop() + $header.innerHeight()) {
                    $('html, body').animate({
                        scrollTop: mapInfoItem.find(".interactive-map-info[data-state-name='" + showState + "']").offset().top - 50 - $header.innerHeight()
                    }, 700);
                }
            }, 300);
        }
    });

    pinsMap.find("path").on("click", function (e) {
        let $this = $(this);
        if ($this.hasClass("active")) {
            let showId = $this.parent().attr("id").slice(0, 2);
            let showState = usaMap.find("path[id='" + showId + "']").data("name");
            usaMap.find("path.active").addClass("hide");
            pinsMap.find("g path.active").addClass("hide");
            $this.addClass("show").removeClass("hide");
            usaMap.find("path[id='" + showId + "']").addClass("show").removeClass("hide");
            mapInfoItem.removeClass("show");
            mapInfoItem.find(".interactive-map-info[data-state-name='" + showState + "']").parent().addClass("show");
            let left = e.offsetX;
            let top = e.offsetY;
            mapInfoItem.css({
                "left": left,
                "top": top
            });
            setTimeout(function () {
                if (mapInfoItem.find(".interactive-map-info[data-state-name='" + showState + "']").offset().top < $window.scrollTop() + $header.innerHeight()) {
                    $('html, body').animate({
                        scrollTop: mapInfoItem.find(".interactive-map-info[data-state-name='" + showState + "']").offset().top - $header.innerHeight() * 2
                    }, 700);
                }
            }, 300);
        }
    });

    $parent.on("click", ".close", function (e) {
        mapInfoItem.removeClass("show");
        usaMap.find("path.active").removeClass("hide show");
        pinsMap.find("g path.active").removeClass("hide");
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/interactiveMap.js